import React, { useEffect, useRef, useCallback } from 'react';
import './Testimonials.css';
import { Star, Quote } from 'lucide-react';

const clientReviews = [
  {
    name: 'Dr. Rahul Sharma',
    role: 'Commercial Client • Trudent Clinic',
    rating: 5,
    review: 'Sakae Studio transformed our clinic into a world-class healthcare space. Their attention to lighting, biophilic design, and workflow efficiency surpassed all expectations.',
  },
  {
    name: 'Ananya & Vikram Reddy',
    role: 'Residential Client • DD Residence',
    rating: 5,
    review: 'Ar. Sameed Ahmed Khan and his team brought our dream villa to life. From the grand entrance to every interior detail, the precision and luxury craftsmanship are unmatchable.',
  },
  {
    name: 'Siddharth Mehta',
    role: 'Real Estate Developer • Skyline Crest',
    rating: 5,
    review: 'Working with Sakae Studio on our high-rise development was seamless. Their 3D VR presentations made spatial planning crystal clear, delivering incredible ROI.',
  },
];

const ReviewCard = ({ review, index }) => {
  const ref = useRef(null);
  const onMouseMove = useCallback((e) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width  - 0.5;
    const y = (e.clientY - rect.top)  / rect.height - 0.5;
    el.style.transform = `perspective(900px) rotateY(${x * 10}deg) rotateX(${-y * 8}deg) scale(1.02)`;
    el.style.boxShadow = `${-x * 16}px ${y * 16}px 45px rgba(0,0,0,0.30), 0 0 0 1px rgba(212,175,55,0.30)`;
  }, []);
  const onMouseLeave = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    el.style.transform = 'perspective(900px) rotateY(0deg) rotateX(0deg) scale(1)';
    el.style.boxShadow = '';
    el.style.transition = 'transform 0.6s ease, box-shadow 0.6s ease';
  }, []);

  return (
    <div
      ref={ref}
      className={`reveal-depth delay-${(index % 3) + 1} bg-white/5 border border-amber-300/20 backdrop-blur-xl p-8 rounded-2xl relative transition-all duration-300 will-change-transform flex flex-col justify-between`}
      onMouseMove={onMouseMove}
      onMouseLeave={onMouseLeave}
    >
      <div>
        <div className="flex items-center justify-between mb-6">
          <div className="flex space-x-1">
            {[...Array(review.rating)].map((_, i) => (
              <Star key={i} size={18} className="text-amber-400 fill-amber-400" />
            ))}
          </div>
          <Quote size={32} className="text-amber-400/20" />
        </div>
        <p className="text-gray-200 text-sm leading-relaxed italic mb-6">
          "{review.review}"
        </p>
      </div>
      <div className="pt-4 border-t border-amber-300/10">
        <h4 className="text-base font-bold font-serif text-white">{review.name}</h4>
        <p className="text-xs text-amber-400">{review.role}</p>
      </div>
    </div>
  );
};

const Testimonials = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://static.elfsight.com/platform/platform.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <section
      className="py-24 relative overflow-hidden text-white"
      style={{
        backgroundColor: '#021a13',
        background: 'linear-gradient(180deg, #021a13 0%, #032419 50%, #021a13 100%)',
        color: "#ffffff"
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16 reveal-left">
          <p className="font-serif text-xs uppercase tracking-widest text-amber-400 mb-2">Client Experience</p>
          <h2 className="text-4xl md:text-5xl font-serif font-normal text-white mb-4">
            What Our Clients Say
          </h2>
          <div className="w-20 h-0.5 bg-gradient-to-r from-amber-600 via-amber-400 to-amber-600 mx-auto mb-4"></div>
          <p className="text-base text-gray-300 max-w-2xl mx-auto">
            Trusted by luxury homeowners, real estate developers, and commercial leaders across India and abroad.
          </p>
        </div>

        {/* 3D Glass Review Showcase */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {clientReviews.map((rev, idx) => (
            <ReviewCard key={idx} review={rev} index={idx} />
          ))}
        </div>

        {/* Embed Elfsight Google Reviews Widget */}
        <div className="elfsight-app-9dc99a7c-43b5-4861-9d45-2f91c8cdf256" data-elfsight-app-lazy></div>
      </div>
    </section>
  );
};

export default Testimonials;
